module.exports = __webpack_public_path__ + "static/media/JO.a235842c.svg";